import { getCurrentVersion } from 'src/dataLayer/localData/designSystem/getCurrentVersion';

export const CURRENT_DS_VERSION = getCurrentVersion();
